import React, { useEffect, useRef } from "react";

/**
 * Reading-progress bar. Scroll handler is passive and rAF-throttled, and it
 * only ever writes one CSS custom property — no React state, no re-renders.
 */
const ScrollProgress = () => {
  const ref = useRef(null);

  useEffect(() => {
    let ticking = false;

    const update = () => {
      ticking = false;
      const el = ref.current;
      if (!el) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? window.scrollY / max : 0;
      el.style.setProperty("--p", Math.min(1, Math.max(0, ratio)).toFixed(4));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return <div ref={ref} className="progress" aria-hidden="true" />;
};

export default ScrollProgress;
